import { useMutation, useQuery } from 'react-query';

import { useSessionStore } from 'session/useSessionStore';
import { IResponseAPI } from 'models/interfaces/IResponseAPI';
import { AlineWeight } from '../models/IAlineWeight';
import { IRunAlineRequest } from '../models/IRunAlineRequest';
import { axios } from 'configurations/axios';
import { IAlineHistoric } from '../models/IAlineHistoric';
import { IRunAlineResponse } from '../models/IRunAlineResponse';

export function useGetAllAlineWeights() {
    const { tenantConfig } = useSessionStore(state => ({
        tenantConfig: state.tenantConfiguration
    }));

    return useQuery(`alineWeightsGetAll`, async () => {
        const response = await axios.request<IResponseAPI<AlineWeight[]>>({
            method: 'get',
            url: tenantConfig?.endpoints.customUrls['aline'] + '/ProjectCustomization/Eneva/GetAlineWeights',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        return response.data.Result;
    });
}

export function useExecuteAline(){
    const { tenantConfig } = useSessionStore(state => ({
        tenantConfig: state.tenantConfiguration
    }));
    return useMutation(`runAline`, async (params: IRunAlineRequest)=>{
        const response = await axios.request<IResponseAPI<IRunAlineResponse>>({
            method: 'post',
            url: tenantConfig?.endpoints.customUrls['aline'] + '/ProjectCustomization/Eneva/ExecuteAline',
            data: params,
            headers: {
                'Content-Type': 'application/json'
            }
        });

        return response.data.Result;
    });
}

export function useGetAlineHistoric(historicOpen: boolean) {
    const { tenantConfig } = useSessionStore(state => ({
        tenantConfig: state.tenantConfiguration
    }));

    return useQuery(`getAlineHistoric` + historicOpen, async () => {
        const response = await axios.request<IResponseAPI<IAlineHistoric[]>>({
            method: 'get',
            url: tenantConfig?.endpoints.customUrls['aline'] + '/ProjectCustomization/Eneva/GetAlineHistoric',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        return response.data.Result;
    },{
        refetchOnWindowFocus: false,
        enabled: historicOpen,
        refetchInterval: 30000
    });
}